<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Create Quiz</h1>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12">
                                        <form class="cForm" id="quiz-create-form" @submit.prevent="createQuiz()">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h2 class="quiz-heading">Select Quiz Pools (One or Multiple)</h2>
                                                </div>
                                                <div class="col-md-3" v-for="pl in poolsList">
                                                    <label class="radioLabel">
                                                        <input type="checkbox" name="pools" :value="pl.quiz_pool_enc_id"
                                                               class="customRadio">
                                                        <div class="quiz-group-box">
                                                            <p class="quiz-class">{{pl.name}}</p>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="error-msg" v-html="poolsError"></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 p20">
                                                    <h2 class="quiz-heading">Quiz Name</h2>
                                                    <div class="pay-input">
                                                        <input type="text" name="name" placeholder="Enter Quiz Name">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 p20">
                                                    <h2 class="quiz-heading">Total Questions</h2>
                                                    <div class="pay-input">
                                                        <input type="number" name="total_ques" placeholder="">
                                                    </div>
                                                </div>
                                                <div class="col-md-4 p20">
                                                    <h2 class="quiz-heading">Min Questions</h2>
                                                    <div class="pay-input">
                                                        <input type="number" name="min" placeholder="">
                                                    </div>
                                                </div>
                                                <div class="col-md-4 p20">
                                                    <h2 class="quiz-heading">Max Questions</h2>
                                                    <div class="pay-input">
                                                        <input type="number" name="max" placeholder="">
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 p20">
                                                    <h2 class="quiz-heading">Set Time Duration</h2>
                                                    <div class="pay-btns">
                                                        <div class="row padd15">
                                                            <div class="col-md-12">
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="duration_type" value="0"
                                                                           class="customRadio" checked>
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">Whole Quiz</div>
                                                                    </div>
                                                                </label>
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="duration_type" value="1"
                                                                           class="customRadio">
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">Per Question</div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="pay-input">
                                                                    <input type="number" name="duration"
                                                                           id="input_t" placeholder="In Minutes">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p20">
                                                    <h2 class="quiz-heading">Total Marks</h2>
                                                    <div class="pay-btns">
                                                        <div class="row padd15">
                                                            <div class="col-md-12">
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="marks_type" value="0"
                                                                           class="customRadio" checked>
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">Whole Quiz</div>
                                                                    </div>
                                                                </label>
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="marks_type" value="1"
                                                                           class="customRadio">
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">Per Question</div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="pay-input">
                                                                    <input type="number" id="marks"
                                                                           name="marks" placeholder="Marks">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p20">
                                                    <h2 class="quiz-heading">Would you like to negative marking for this
                                                        quiz
                                                    </h2>
                                                    <div class="pay-btns">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="is_nagetive_marking"
                                                                           value="1" class="customRadio" @change="negativeMarking($event)" checked>
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">Yes</div>
                                                                    </div>
                                                                </label>
                                                                <label class="radioLabel widthAuto">
                                                                    <input type="radio" name="is_nagetive_marking"
                                                                           value="0" class="customRadio" @change="negativeMarking($event)">
                                                                    <div class="quiz-group-box btn-shape">
                                                                        <div class="quiz-subject">No</div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="marking-details" v-if="negativeMark">
                                                        <div class="pay-input">
                                                            <input type="number" id="penelty_score"
                                                                   name="nagetive_marks"
                                                                   placeholder="Penalty For Every Wrong answer">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 p20">
                                                    <h2 class="quiz-heading">
                                                        Quiz for Class
                                                    </h2>
                                                    <div class="pay-input">
                                                        <select name="class" @change="setSections($event)">
                                                            <option value="">Select Class</option>
                                                            <option v-for="cl in classesList"
                                                                    v-bind:value="cl.assigned_college_enc_id">
                                                                {{cl.course_name}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 p20" v-if="sections.length">
                                                    <h2 class="quiz-heading">Select Section</h2>
                                                    <label class="radioLabel widthAuto" v-for="sc in sections">
                                                        <input type="checkbox" name="sections"
                                                               v-bind:value="sc.section_name" class="customRadio">
                                                        <div class="quiz-group-box btn-shape">
                                                            <div class="quiz-subject">{{sc.section_name}}</div>
                                                        </div>
                                                    </label>
                                                    <div class="error-msg" v-html="sectionsError"></div>

                                                    <!--                                                    <div class="pay-input">-->
                                                    <!--                                                        <select name="class">-->
                                                    <!--                                                            <option>Select Section</option>-->
                                                    <!--                                                            <option v-for="sc in sections" v-bind:value="sc.section_enc_id">-->
                                                    <!--                                                                {{sc.section_name}}-->
                                                    <!--                                                            </option>-->
                                                    <!--                                                        </select>-->
                                                    <!--                                                    </div>-->
                                                </div>
                                                <div class="col-md-12 text-center">
                                                    <div class="form-group margin-top-20">
                                                        <button type="submit" class="add-course">Create Quiz</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from '../../components/CollegeSideNavLayout.vue'
    import collegeBanner from '../../components/collegeBanner'
    import axios from "axios";
    import toastr from "../../../public/js/toastr";
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data() {
            return {
                poolsList: [],
                classesList: [],
                sections: [],
                poolsError:'',
                sectionsError:'',
                negativeMark:true,
            }
        },
        mounted() {
            this.getPools();
            this.getClasses();
        },
        methods: {
            getPools() {
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/quiz/get-pools`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.poolsList = response['data']['response']['data'];
                    }
                });
            },
            getClasses() {
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/quiz/courses`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.classesList = response['data']['response']['courses'];
                    }
                });
            },
            setSections(event) {
                var t = this;
                var element = event.currentTarget
                var val = element.value;
                for (var i = 0; i < t.classesList.length; i++) {
                    if (t.classesList[i].assigned_college_enc_id == val) {
                        if (t.classesList[i].collegeSections.length) {
                            t.sections = t.classesList[i].collegeSections;
                        } else {
                            t.sections = [];
                        }
                    }
                }
            },
            createQuiz() {
                var t = this;
                var url = this.$store.getters.getDomain;

                if (!t.validateForm()) {
                    return false;
                }
                var elements = document.getElementById('quiz-create-form').elements;
                var obj = {};
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    var itemType = elements.item(i).getAttribute('type');
                    if (itemType != "radio") {
                        if (item.name != "") {
                            obj[item.name] = item.value;
                        }
                    } else {
                        if (elements.item(i).checked) {
                            obj[item.name] = item.value;
                        }
                    }
                }
                var pools_arr = [];
                var el_pools = document.getElementsByName('pools');
                for (var k = 0; k < el_pools.length; k++) {
                    if (el_pools[k].checked) {
                        pools_arr.push(el_pools[k].value);
                    }
                }
                if (!pools_arr.length) {
                    t.poolsError = "Choose atleast one.";
                    return false;
                } else {
                    t.poolsError = "";
                }
                obj['pools'] = pools_arr;
                var sections_arr = [];
                var el_sections = document.getElementsByName('sections');
                if(el_sections.length) {
                    for (var k = 0; k < el_sections.length; k++) {
                        if (el_sections[k].checked) {
                            sections_arr.push(el_sections[k].value);
                        }
                    }
                    if (!sections_arr.length) {
                        t.sectionsError = "Choose atleast one.";
                        return false;
                    } else {
                        t.sectionsError = "";
                    }
                }
                obj['sections'] = sections_arr;
                showLoader();
                axios.post(`${url}api/v2/quiz/create-quiz`, obj, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Quiz Created successfully', 'Success');
                            t.$router.push({path: '/dashboard'});
                            return false;
                        } else {
                            toastr.error('Something went wrong. Please try again.', 'Oops!!');
                            return false;
                        }
                    }).catch(function (error) {
                    hideLoader();
                    toastr.error('Something went wrong. Please try again.', 'Oops!!');
                })
            },
            validateForm: function () {
                var x, y, z, i, valid = true, a = this;
                x = document.getElementById("quiz-create-form");
                y = x.getElementsByTagName("input");
                for (i = 0; i < y.length; i++) {
                    if (y[i].value == "") {
                        y[i].className += " invalid";
                        valid = false;
                    } else {
                        y[i].classList.remove('invalid');
                    }
                }
                z = x.getElementsByTagName('select');
                if (z.length > 0) {
                    for (i = 0; i < z.length; i++) {
                        if (z[i].value == "") {
                            z[i].className += " invalid";
                            valid = false;
                        } else {
                            z[i].classList.remove('invalid');
                        }
                    }
                }
                return valid;
            },
            negativeMarking(event){
                var t = this;
                var element = event.currentTarget;
                var val = element.value;
                if(val == 1){
                    t.negativeMark = true;
                } else {
                    t.negativeMark = false;
                }
            },
        }
    }
</script>

<style scoped>
    .quiz-heading {
        font-size: 16px;
        margin: 0;
    }

    .cForm {
        padding: 0 15px;
    }

    .p20 {
        padding-top: 20px;
    }

    .btn-shape {
        width: auto;
        border-radius: 0px !important;
        min-height: 20px !important;
        padding: 10px 15px !important;
        margin-top: 10px !important;
    }

    .widthAuto {
        width: auto;
        margin-right: 15px;
    }

    .pay-input {
        margin-top: 5px;
    }

    .pay-input select {
        width: 100%;
        border: none;
        padding: 8px 10px;
    }

    .add-course {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .add-course:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }
</style>